// @ts-nocheck
import * as React from 'react';
import Box from '@mui/material/Box';
import SinapTheme from "../styles/SinapTheme";
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? SinapTheme.palette.primary.main : SinapTheme.palette.primary.light,
    },
}));

export const SuccessProgress = styled(BorderLinearProgress)(({ theme }) => ({
    [`& .${linearProgressClasses.bar}`]: {
        backgroundColor: theme.palette.mode === 'light' ? SinapTheme.palette.success.main : SinapTheme.palette.success.light,
    },
}));

/**
 *
 * @param complete Bool que especifica si se terminó de completar o no
 * @param fail Bool que especifica si hubo un fallo y se tiene que vaciar
 * @param inicioFin Bool que especifica si tiene que arrancar a cargar o no
 * @param setInicioFin Función para actualizar el estado de inicio fin y que no cargue mas
 * @returns {JSX.Element}
 * @constructor
 *
 * Por fuera, hay que setear el complete a true para que la barra se llene al maximo, sino se queda al 90%
 */
export default function BarraDeCarga({ complete, fail, inicioFin, setInicioFin }) {
    const [progress, setProgress] = React.useState(0);

    React.useEffect(() => {
        if (!inicioFin) return;

        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                if (fail) {
                    return 0;
                }

                if (oldProgress === 100) {
                    return oldProgress;
                }

                if (complete) {
                    return 100;
                }

                const diff = 35;
                return Math.min(oldProgress + diff, 90);
            });
        }, 500);

        return () => clearInterval(timer);
    }, [inicioFin, complete, fail]);

    React.useEffect(() => {
        if (fail) {
            setInicioFin(false);
        } else if (progress === 100) {
            setInicioFin(false);
        }
    }, [progress, fail, setInicioFin]);

    return (
        <Box sx={{ width: '100%' }}>
            {progress !== 100 ? (
                <BorderLinearProgress variant="determinate" value={progress} />
            ) : (
                <SuccessProgress variant="determinate" value={progress} />
            )}
        </Box>
    );
}
